/** @format */

import React, { Component } from 'react';
import {
  Container,
  Grid,
  Segment,
  Icon,
  Button,
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import database from '../../../firebase/config';
import RequestClient from './RequestClient/RequestClient';
import RequestChannelSelect from './RequestChannelSelect/RequestChannelSelect';
import NewEditRequestPart from './RequestParts/NewEditRequestPart/NewEditRequestPart';
import NewEditRequestPartOption from './RequestParts/NewEditRequestPartOption/NewEditRequestPartOption';
import ClientEdit from '../../Clients/Client/ClientEdit/ClientEdit';
import ClientAddressEdit from '../../Clients/Client/ClientEdit/ClientAddressEdit/ClientAddressEdit';
import RequestInfo from './RequestInfo/RequestInfo';
import RequestCommunication from './RequestCommunication/RequestCommunication';
import RequestCommunicationModal from './RequestCommunication/RequestCommunicationModal/RequestCommunicationModal';
import RequestNoteModal from './RequestInfo/RequestNoteModal/RequestNoteModal';
import RequestParts from './RequestParts/RequestParts';
import NewEditRequestToolbar from './NewEditRequestToolbar/NewEditRequestToolbar';
import SalesForm from '../../Sales/SalesForm/SalesForm';
import LeaveRequestModal from './LeaveRequestModal/LeaveRequestModal';
import HasBeenPrintedModal from '../../AppLayout/HasBeenPrintedModal/HasBeenPrintedModal';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import './NewEditRequests.css';

@inject(
  'UserStore',
  'RequestsStore',
  'ClientsStore',
  'SalesStore',
  'VisitedStore',
)
@observer
class NewEditRequests extends Component {
  state = {
    clientTypeOptions: [
      {
        value: 'azienda',
        text: 'azienda',
        key: 'azienda',
      },
      {
        value: 'privato',
        text: 'privato',
        key: 'privato',
      },
    ],
  };

  componentDidMount() {
    const { UserStore, RequestsStore, ClientsStore } = this.props;

    database
      .ref('/requests/' + RequestsStore.requestsParams.currentRequestId)
      .off('value');
    if (typeof this.props.match.params.requestId !== 'undefined') {
      RequestsStore.loadCurrentRequest(
        this.props.match.params.requestId,
        UserStore.user.role,
        true,
      );
    } else {
      RequestsStore.resetCurrentRequest();
      ClientsStore.resetCurrentClient();
    }
  }

  renderChannelsAndNewPart() {
    const { UserStore, RequestsStore } = this.props;
    if (UserStore.user.role !== 'warehouse' && RequestsStore.isActive) {
      return [
        <Segment key="channel-select">
          <RequestChannelSelect />
        </Segment>,
        <Segment
          key="add-part-button"
          disabled={
            RequestsStore.requestsParams.reqChannelSelected ? false : true
          }
        >
          <Button
            onClick={() => RequestsStore.togglePartForm()}
            color="green"
            size="small"
            fluid
          >
            <Icon name="plus" /> Aggiungi Ricambio
          </Button>
        </Segment>,
      ];
    }
  }

  renderRequestsClient = () => {
    const { ClientsStore } = this.props;
    if (!ClientsStore.clientsParams.clientRemoved) {
      return <RequestClient options={this.state.clientTypeOptions} />;
    } else {
      return <h2>Il cliente è stato rimosso dal gestionale</h2>;
    }
  };

  renderRequestNavigationButtons = () => {
    const { RequestsStore, VisitedStore, UserStore } = this.props;

    const onNextClick = () => {
      this.props.history.push(`/requests/${RequestsStore.nextRequestId}/view`);

      VisitedStore.addToVisited(
        `/requests/${RequestsStore.nextRequestId}/view`,
      );

      RequestsStore.loadCurrentRequest(
        RequestsStore.nextRequestId,
        UserStore.user.role,
        true,
      );
    };

    const onPreviousClick = () => {
      this.props.history.push(
        `/requests/${RequestsStore.previousRequestId}/view`,
      );

      VisitedStore.addToVisited(
        `/requests/${RequestsStore.previousRequestId}/view`,
      );

      RequestsStore.loadCurrentRequest(
        RequestsStore.previousRequestId,
        UserStore.user.role,
        true,
      );
    };

    return (
      <Grid.Row>
        <Grid.Column tablet={16} computer={2} />
        <Grid.Column tablet={16} computer={12}>
          <Button
            onClick={onPreviousClick}
            disabled={!RequestsStore.previousRequestId}
          >
            <Icon name="backward" />
            {intl.get('requests.previous')}
          </Button>
          <Button
            onClick={onNextClick}
            disabled={!RequestsStore.nextRequestId}
            floated="right"
          >
            <Icon name="forward" />
            {intl.get('requests.next')}
          </Button>
        </Grid.Column>
        <Grid.Column tablet={16} computer={2} />
      </Grid.Row>
    );
  };

  renderNewEditRequest = () => {
    const { UserStore } = this.props;
    const isExternal = UserStore.user.isExternal;
    return [
      <NewEditRequestToolbar
        key="newEditRequest-toolbar"
        currentRequestId={
          typeof this.props.match.params.requestId !== 'undefined'
            ? this.props.match.params.requestId
            : null
        }
      />,
      <Container
        className="content-container"
        key={
          typeof this.props.match.params.requestId !== 'undefined'
            ? 'form-' + this.props.match.params.requestId
            : 'form'
        }
      >
        <Grid>
          {typeof this.props.match.params.requestId !== 'undefined' &&
            this.renderRequestNavigationButtons()}
          <Grid.Row>
            <Grid.Column tablet={16} computer={2} />
            <Grid.Column tablet={16} computer={12}>
              {!isExternal && (
                <Segment padded>{this.renderRequestsClient()}</Segment>
              )}
              <RequestInfo />
              <RequestCommunication />
              {this.renderChannelsAndNewPart()}
              <RequestParts
                requestId={
                  typeof this.props.match.params.requestId !== 'undefined'
                    ? this.props.match.params.requestId
                    : null
                }
              />
            </Grid.Column>
            <Grid.Column tablet={16} computer={2} />
          </Grid.Row>
        </Grid>
      </Container>,
      <NewEditRequestPart key="new-edit-requestPart" />,
      <NewEditRequestPartOption key="new-edit-requestPartOption" />,
      <SalesForm key="edit-sale" />,
      <ClientEdit key="client-edit" />,
      <ClientAddressEdit key="client-address-edit" />,
      <LeaveRequestModal key="leave-request-modal" />,
      <HasBeenPrintedModal key="hasBeenPrintedModal" />,
      <RequestNoteModal key="requestNoteModal" />,
      <RequestCommunicationModal key="requestCommunicationModal" />,
    ];
  };

  renderNewEditRequestCondition = () => {
    const { RequestsStore } = this.props;
    if (
      typeof this.props.match.params.requestId !== 'undefined' &&
      this.props.match !== null
    ) {
      if (RequestsStore.requestsParams.currentRequestLoaded) {
        return this.renderNewEditRequest();
      } else {
        if (RequestsStore.requestsParams.requestNotFound === false) {
          return (
            <Dimmer active inverted>
              <Loader inverted>Loading</Loader>
            </Dimmer>
          );
        } else {
          return (
            <Container className="content-container">
              <Grid>
                <Grid.Column tablet={16} computer={16}>
                  <h2>La Richiesta è stata rimossa dal sistema</h2>
                </Grid.Column>
              </Grid>
            </Container>
          );
        }
      }
    } else {
      return this.renderNewEditRequest();
    }
  };
  render() {
    return <div>{this.renderNewEditRequestCondition()}</div>;
  }
}

export default NewEditRequests;
